{{ textByTextContent }}
<a class="pointer" *ngIf="!isContentToggled && !fixedLength" (click)="toggleContent()">Read More</a>
<a class="pointer" *ngIf="isContentToggled" (click)="toggleContent()">Collapse</a>
